module.exports = __webpack_public_path__ + "static/media/karriere_suedtirol.96e7b4d6.svg";